export const SET_SELECT = 'nodeStatus/setSelect';
export const SET_EDIT = 'nodeStatus/setEdit';
export const GET_NODE_INFO = 'nodeStatus/getNodeInfo';
export const CLEAR_ALL = 'nodeStatus/clearAll';